var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:" fixed-center row justify-center items-center"},[_c('select-lang',{attrs:{"languages":_vm.info.languages},on:{"click":_vm.onLang}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }